import { Link } from 'react-router-dom';
import Navbar from './Navbar';

const heroCards = [
  {
    icon: 'ri-gamepad-fill',
    iconBg: 'bg-orange-500',
    label: 'Browse our best casinos',
    to: '/best-aus-casinos',
    iconImage: true,
    badge: 'FREE',
  },
  {
    icon: 'ri-thumb-up-fill',
    iconBg: 'bg-orange-400',
    label: 'Read our casino reviews',
    to: '/reviews',
  },
  {
    icon: 'ri-funds-box-fill',
    iconBg: 'bg-blue-400',
    label: 'Calculate you win rate',
    to: '/best-for-games',
  },
  {
    icon: ' ri-vip-crown-2-fill',
    iconBg: 'bg-purple-400',
    label: 'Bonuses & Promotions',
    to: '/my-top-picks',
  },
];

export default function HeroSection() {
  return (
    <>
      <Navbar />

      <div className="bg-[#5b21b6] w-full">
        <div className="max-w-7xl mx-auto px-6 py-14 flex flex-col lg:flex-row items-center gap-10">
          {/* Left: Text */}
          <div className="flex-1 min-w-0">
            <h1 className="text-4xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
              Guiding you to play<br />
              <span className="text-orange-400">safe casinos</span>
            </h1>
            <p className="text-purple-200 text-base lg:text-lg max-w-md leading-relaxed">
            Since 2020, we’ve helped players choose better casinos with confidence.
            Dive into expert reviews, smart comparison tools, and trusted guides designed to give you the edge.
            </p>
          </div>

          {/* Right: 2x2 Card Grid */}
          <div className="flex-shrink-0 w-full lg:w-auto">
            <div className="grid grid-cols-2 gap-3 w-full lg:w-[420px]">
              {heroCards.map((card) => (
                <Link
                  key={card.to + card.label}
                  to={card.to}
                  className="group bg-[#1e0f4e] hover:bg-[#2a1660] border border-purple-700/40 rounded-xl p-5 flex flex-col justify-between min-h-[130px] transition-colors cursor-pointer"
                >
                  <div className="flex items-start justify-between">
                    {/* Icon area */}
                    <div className="relative w-14 h-14 flex items-center justify-center">
                      <div className={`w-12 h-12 ${card.iconBg} rounded-full flex items-center justify-center opacity-90`}>
                        <i className={`${card.icon} text-2xl text-white`}></i>
                      </div>
                      {card.badge && (
                        <span className="absolute -bottom-1 -right-1 px-1.5 py-0.5 bg-orange-500 text-white text-[10px] font-bold rounded">
                          {card.badge}
                        </span>
                      )}
                    </div>
                    {/* Arrow */}
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xl text-white group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                  <span className="text-white font-semibold text-sm mt-3 leading-snug">
                    {card.label}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
